<template>
<teleport to="#sd-mount">
  <transition name="Modal" appear>
    <component ref="el" v-if="open$" :is="tag || 'div'" class="Modal t-miniscroll" v-bind="$attrs"
        :style="`--level: ${ level - 1}`" @click="onClick">
      <div class="Modal__wrapper" @click.self="onBackdrop">
        <slot name="container" v-bind="{ close, data: open$ !== true ? open$ : null }">
          <div class="Modal__container">

            <div v-if="$slots.header" class="Modal__header">
              <button class="btn btn--clear Modal__close" name="close-modal" type="button">
                <Icon name="cross" />
              </button>
              <slot name="header" />
            </div>

            <div class="Modal__body">
              <slot />
            </div>

            <div v-if="$slots.footer" class="Modal__footer">
              <slot name="footer" />
            </div>
          </div>
        </slot>
      </div>
    </component>
  </transition>
</teleport>
</template>
<script>
import Icon from '@ohmsd/v-ui/components/Icon';

var count = 0;

export default {
  name: 'Modal',
  emits: ['update:open', 'close', 'open'],
  inheritAttrs: false,
  mixins: [{ props: ['open'] }],

  data: () => ({ open$$: false, level: 0 }),

  methods: {
    toggle (data = !this.open$) {
      if (this.open$ && this.preventClose == true) {
        return;
      }

      const preventClosingClosed = !!this.open$$ === false && !!data === false;

      if (this.open !== undefined)
        this.$emit('update:open', data);
      else
        this.open$$ = data;

      if (!data) {
        if (!preventClosingClosed)
          this.$emit('close');
      }
      else
        this.$emit('open');
      return data;
    },

    onToggle (open = this.open) {
      count += open ? 1 : -1;
      if (open)
        this.level = count;
    },

    onEscape (e) {
      if (e.keyCode === 27)
        this.close();
    },

    onBackdrop (e) {
      if (e.target === e.currentTarget && this.preventClose !== 'backdrop') {
        if (this.$refs.el.querySelector('form')) {
          const MSG = `Unsaved changes will be lost.
            Are you sure you want to close this dialog?`;
          if (window.confirm(MSG))
            this.close();
        }
      }
    },

    close () {
      this.toggle(false);
    },

    onClick (e) {
      if (e.target?.name === 'close-modal')
        this.close();
    },
  },

  watch: {
    open$: 'onToggle',
  },

  computed: {
    open$ () {
      return this.open !== undefined ? this.open : this.open$$;
    },
  },

  mounted () {
    if (this.open$)
      this.onToggle(true);
    document.addEventListener('keydown', this.onEscape);
  },

  unmounted () {
    document.removeEventListener('keydown', this.onEscape);
  },

  props: {
    tag: ([String, Object]),
    preventClose: ({ type: [Boolean, String], default: false }),
  },

  components: { Icon },
};

</script>
<style>
.Modal {
  --z-index: var(--zi-modal, 2100);
  --level: 0;
  position: fixed;
  z-index: calc(var(--z-index) + var(--level));
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: block;
  transition: opacity .3s ease;
  overflow-y: auto;

  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    /*pointer-events: none;*/
    padding: var(--page-pad);
    /*overflow-y: auto;*/
    min-height: 100vh;
  }

  & &__container {
    pointer-events: initial;
    width: var(--modal-w, 640px);
    /*margin: 0px auto;*/
    /*padding: 20px 30px;*/
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    /*font-family: Helvetica, Arial, sans-serif;*/
    font: 400 14px Montserrat;
    /*max-height: calc(100vh - var(--page-pad) * 2);*/
  }

  & &__header {
    position: relative;
    background-color: var(--white);
    border-radius: 3px;
    border-bottom: 1px solid var(--black-10);
    padding: var(--page-pad);
    padding-bottom: calc(var(--main-pad) + 4px);
  }

  & &__header h3 {
    margin: 0;
    color: var(--black);
    font: 600 18px Montserrat;

    position: sticky;
    top: 0;
/*    background: #ffffffcc;*/
    /*z-index: 10;*/
    border-radius: 3px;
  }

  & &__body {
    /*overflow-x: hidden;*/
    position: relative;
    /*margin: 20px 0;*/
    padding: var(--page-pad);
    padding-top: var(--main-pad);
  }

  & &__footer {
    position: relative;
    padding: 16px var(--page-pad);
    border-top: 1px solid var(--black-10);
    text-align: left;
    background-color: var(--white);
    border-radius: 3px;
    min-height: 64px;
  }

  & &__close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px;
    opacity: .5;
    cursor: pointer;
    height: auto;
    background-color: white;

    &:hover {
      opacity: 1;
    }

    i {
      pointer-events: none;
    }
  }

  &.--scroll .Modal {
    &__container {
      max-height: calc(100vh - 2 * var(--page-pad));
      display: flex;
      flex-direction: column;
    }

    &__body {
      overflow-y: auto;
    }
  }

  &.--wide .Modal {
    &__container {
      width: 100%;
      max-width: 1120px;
      min-width: var(--modal-w);
    }
  }

  &.--full-h .Modal {
    &__container {
      height: calc(100vh - 2 * var(--page-pad));
    }

    &__body {
      flex-grow: 2;
    }
  }

  &.--max-full-h .Modal {
    &__container {
      max-height: calc(100vh - 2 * var(--page-pad));
    }
  }
}

.Modal-enter-from, .Modal-leave-active {
  opacity: 0;
}

.Modal-leave-active .Modal__container {
  transform: scale(1.1);
}

.Modal-enter-from .Modal__container {
  transform: scale(.9);
}
</style>
